"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LargePagination = void 0;

var _react = _interopRequireDefault(require("react"));

var _ChevronIcon = require("../../svgs/ChevronIcon");

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Link = require("../Link");

var _Text = require("../Text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** LargePagination */
var LargePagination = function LargePagination(props) {
  var getHref = props.getHref,
      hasNextPage = props.hasNextPage,
      onClick = props.onClick,
      onNext = props.onNext,
      _props$pageCursors = props.pageCursors,
      around = _props$pageCursors.around,
      first = _props$pageCursors.first,
      last = _props$pageCursors.last,
      previous = _props$pageCursors.previous;

  var handlePrevClick = function handlePrevClick(event) {
    if (previous) {
      onClick(previous.cursor, previous.page, event);
    }
  };

  var handleNextClick = function handleNextClick(event) {
    onNext(event, nextPage);
  };

  var aroundPages = around.map(function (pageCursor) {
    var cursor = pageCursor.cursor,
        page = pageCursor.page;
    var key = cursor + page;
    return /*#__PURE__*/_react.default.createElement(Page, {
      getHref: getHref,
      key: key,
      onClick: onClick,
      pageCursor: pageCursor
    });
  });
  var nextPage = ((previous === null || previous === void 0 ? void 0 : previous.page) || 0) + 2;

  var DotDotDot = function DotDotDot() {
    return /*#__PURE__*/_react.default.createElement(_Text.Text, {
      color: "black30",
      display: "inline",
      mx: 0.5,
      variant: "mediumText"
    }, "...");
  };

  var FirstPage = function FirstPage(p) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Page, {
      onClick: onClick,
      pageCursor: p.pageCursor,
      getHref: getHref
    }), /*#__PURE__*/_react.default.createElement(DotDotDot, null));
  };

  var LastPage = function LastPage(p) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(DotDotDot, null), /*#__PURE__*/_react.default.createElement(Page, {
      onClick: onClick,
      pageCursor: p.pageCursor,
      getHref: getHref
    }));
  };

  return /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    alignItems: "baseline",
    flexDirection: "row",
    justifyContent: "flex-end",
    mr: -1
  }, first && /*#__PURE__*/_react.default.createElement(FirstPage, {
    onClick: onClick,
    pageCursor: first,
    getHref: getHref
  }), aroundPages, last && /*#__PURE__*/_react.default.createElement(LastPage, {
    onClick: onClick,
    pageCursor: last,
    getHref: getHref
  }), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    ml: 4
  }, /*#__PURE__*/_react.default.createElement(PrevButton, {
    enabled: !!previous,
    getHref: getHref,
    onClick: handlePrevClick,
    page: previous === null || previous === void 0 ? void 0 : previous.page
  }), /*#__PURE__*/_react.default.createElement(NextButton, {
    enabled: hasNextPage,
    getHref: getHref,
    onClick: handleNextClick,
    page: nextPage
  })));
};

exports.LargePagination = LargePagination;
LargePagination.displayName = "LargePagination";

var Page = function Page(props) {
  var getHref = props.getHref,
      onClick = props.onClick,
      pageCursor = props.pageCursor;
  var cursor = pageCursor.cursor,
      isCurrent = pageCursor.isCurrent,
      page = pageCursor.page;

  var handleClick = function handleClick(event) {
    onClick(cursor, page, event);
  };

  var highlight = isCurrent ? "black5" : "white100";
  var href = "";

  if (page && typeof getHref !== "undefined") {
    href = getHref(page);
  }

  return /*#__PURE__*/_react.default.createElement(_Box.Box, {
    bg: highlight,
    borderRadius: 2
  }, /*#__PURE__*/_react.default.createElement(_Link.Link, {
    href: href,
    onClick: handleClick,
    underlineBehavior: "hover"
  }, /*#__PURE__*/_react.default.createElement(_Text.Text, {
    px: 0.5,
    variant: "mediumText"
  }, page)));
};

Page.displayName = "Page";

var PrevButton = function PrevButton(props) {
  var enabled = props.enabled,
      getHref = props.getHref,
      onClick = props.onClick,
      page = props.page;
  var opacity = enabled ? 1 : 0.1;
  var pointerEvents = enabled ? "inherit" : "none";
  var href = "";

  if (enabled && page && typeof getHref !== "undefined") {
    href = getHref(page);
  }

  return /*#__PURE__*/_react.default.createElement(_Link.Link, {
    href: href,
    onClick: onClick,
    style: {
      opacity: opacity,
      pointerEvents: pointerEvents
    },
    underlineBehavior: "hover"
  }, /*#__PURE__*/_react.default.createElement(_ChevronIcon.ChevronIcon, {
    direction: "left",
    top: 0.5
  }), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    display: "inline",
    px: 0.5,
    variant: "mediumText"
  }, "Prev"));
};

PrevButton.displayName = "PrevButton";

var NextButton = function NextButton(props) {
  var enabled = props.enabled,
      getHref = props.getHref,
      onClick = props.onClick,
      page = props.page;
  var opacity = enabled ? 1 : 0.1;
  var pointerEvents = enabled ? "inherit" : "none";
  var href = "";

  if (enabled && page && typeof getHref !== "undefined") {
    href = getHref(page);
  }

  return /*#__PURE__*/_react.default.createElement(_Link.Link, {
    href: href,
    onClick: onClick,
    style: {
      opacity: opacity,
      pointerEvents: pointerEvents
    },
    underlineBehavior: "hover"
  }, /*#__PURE__*/_react.default.createElement(_Text.Text, {
    display: "inline",
    px: 0.5,
    variant: "mediumText"
  }, "Next"), /*#__PURE__*/_react.default.createElement(_ChevronIcon.ChevronIcon, {
    direction: "right",
    top: 0.5
  }));
};

NextButton.displayName = "NextButton";
//# sourceMappingURL=LargePagination.js.map